import { translationKey } from '@change-corgi/core/i18n';
import {
	iconCampaign,
	iconDescription,
	iconGroups,
	iconLink,
	iconShare,
	iconTrendingUp,
} from '@change-corgi/design-system-legacy/icons';

import type { DynamicTranslationConfig } from './types';

// static task properties (move to helper functions?)
export const TASKS_CONFIGS = {
	create_petition: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.create_petition.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.create_petition.description'),
		icon: iconDescription,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.create_petition.cta'),
	},
	download_flyer: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.download_flyer.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.download_flyer.description'),
		icon: iconGroups,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.shared.flyer.multi_modal_cta_button'),
	},
	customize_link: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.customize_link.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.customize_link.description'),
		icon: iconLink,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.customize_link.cta'),
	},
	share_communities: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_communities.title'),
		description: translationKey(
			'corgi.petition.starter_dashboard.steps_to_victory.tasks.share_communities.description',
		),
		icon: iconGroups,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_communities.cta'),
	},
	promote_basic: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_basic.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_basic.description'),
		icon: iconTrendingUp,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_basic.cta'),
	},
	promote_high_performer: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_country.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_country.description'),
		icon: iconTrendingUp,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.promote_country.cta'),
	},
	share_friends: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_friends.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_friends.description'),
		icon: iconShare,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_friends.cta'),
	},
	share_social: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_social.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_social.description'),
		icon: iconShare,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_social.cta'),
	},
	share_supporters: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_supporters.title'),
		description: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_supporters.description'),
		icon: iconCampaign,
		primaryActionText: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_supporters.cta'),
	},
	share_top_starter_share_channel: {
		title: translationKey('corgi.petition.starter_dashboard.steps_to_victory.tasks.share_top_recruited_source.title'),
		description: translationKey(
			'corgi.petition.starter_dashboard.steps_to_victory.tasks.share_top_recruited_source.description',
		),
		icon: iconShare,
		primaryActionText: translationKey(
			'corgi.petition.starter_dashboard.steps_to_victory.tasks.share_top_recruited_source.cta',
		),
	},
} as const;

export const DYNAMIC_TASKS_CONFIG: Record<string, DynamicTranslationConfig> = {
	share_top_starter_share_channel: {
		channel: {
			email: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.email'),
			facebook: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.facebook',
			),
			instagram: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.instagram',
			),
			line: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.line'),
			linkedin: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.linkedin',
			),
			linktree: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.linktree',
			),
			nextdoor: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.nextdoor',
			),
			reddit: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.reddit'),
			sms: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.sms'),
			snapchat: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.snapchat',
			),
			telegram: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.telegram',
			),
			tiktok: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.tiktok'),
			twitter: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.twitter'),
			vk: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.vk'),
			whatsapp: translationKey(
				'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.whatsapp',
			),
			youtube: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.youtube'),
		},
	},
} as const;
